export const FLOWS = {
  WORDPRESS: 'WORDPRESS',
  WORDPRESS_IA: 'WORDPRESS_IA',
  SITE_BUILDER: 'SITE_BUILDER',
  OTHER_TOOLS: 'OTHER_TOOLS',
  WORDPRESS_MIGRATION: 'WORDPRESS_MIGRATION',
};
